import { userLanguage, ValidLanguages } from '$translations/index';
import { ErrorMessageEn, ErrorMessageEs } from '../../../../constants/alerts';
import { errorHandler } from '../../../utils';
import {
  ValidateCaptchaOutput,
  SecurityBuilder,
  ValidateCaptchaInput,
} from '../security.types';

export const validateCaptchaV2Token = (builder: SecurityBuilder) =>
  builder.mutation<ValidateCaptchaOutput, ValidateCaptchaInput>({
    query: ({ Token, Action }) => ({
      url: `/security/recaptcha/verify/v2`,
      method: 'POST',
      body: { Token, Action },
    }),
    transformErrorResponse: (error) => {
      errorHandler(
        '[recaptchaV2Validation]',
        userLanguage === ValidLanguages.es
          ? ErrorMessageEs.CaptchaValidationError
          : ErrorMessageEn.CaptchaValidationError,
        error,
        true
      );
      return error.data;
    },
  });
